import type { LandingCopy } from './types'

export const landingUk: LandingCopy = {
  heroTitle: 'Розумійте англійську прямо під час читання.',
  heroSubtitleLines: ['Натисніть на будь-яке слово.', 'Ми пояснимо його.', 'Ви його запам’ятаєте.'],
  demoHint: 'Реєстрація не потрібна',
  demoReadLabel: 'Читати',
  demoUnderstandLabel: 'Зрозуміти',
  demoTapHint: 'Натисніть на підсвічене слово, щоб побачити значення',
  demoMeans: 'Значення',
  demoInContext: 'У цьому реченні',
  demoExampleLabel: 'Приклад',
  demoLocalizedNote: 'Зареєструйтесь, щоб зберігати слова і зустрічати їх знову в повтореннях.',
  signUpToSave: 'Зареєструйтесь, щоб зберігати слова',
  savedNudge: 'Збережено — завтра повторите «{word}».',
  capabilitiesTitle: 'Двигун вашого прогресу',
  capabilitiesSubtitle:
    'Не просто читання. Слова, які ви обираєте, стають статтями, практикою, тестами й повторенням — один цикл, який неперервно веде вперед.',
  capabilities: [
    {
      title: 'Читати й розуміти',
      body: 'Натисніть слово або фразу — пояснення в контексті.',
    },
    {
      title: 'Ваш словник',
      body: 'Зберігайте важливе — особистий список для росту.',
    },
    {
      title: 'Повторення',
      body: 'Інтервальне повторення, коли майже забули.',
    },
    {
      title: 'Статті з ваших слів',
      body: 'ШІ пише тексти на вашому рівні навколо збережених слів.',
    },
    {
      title: 'Практика',
      body: 'Історії та уроки зі слів, які ви вже знаєте.',
    },
    {
      title: 'Тести',
      body: 'Перевірте себе і подивіться, що справді засвоїлося.',
    },
  ],
  finalTitle: 'Готові перетворити слова на прогрес?',
  getStarted: 'Почати безкоштовно',
  signIn: 'Увійти',
  footerFaq: 'FAQ',
  footerPrivacy: 'Политика конфіденциальности',
  footerTerms: 'Умови використання',
  localeSwitcherLabel: 'Мова',
}
